// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { apiGet, apiPost, apiPatch } from '../../utils/apiClient';
import './UserManagement.css';

interface UserManagementProps {
  onClose?: () => void;
  onRefresh?: () => void;
}

interface UserFormData {
  username: string;
  password: string;
  email: string;
  full_name: string;
  role: string;
}

export default function UserManagement({ onClose }: UserManagementProps) {
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [showCreateForm, setShowCreateForm] = useState<boolean>(false);
  const [formData, setFormData] = useState<UserFormData>({
    username: '',
    password: '',
    email: '',
    full_name: '',
    role: 'user'
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await apiGet('/api/admin/users') as any;
      if (response.success) {
        setUsers(response.users);
      }
    } catch (error: any) {
      console.error('获取用户列表失败:', error);
      alert('获取用户列表失败');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateUser = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.username || !formData.password) {
      alert('用户名和密码必填');
      return;
    }

    try {
      const response = await apiPost('/api/admin/users', formData) as any;
      if (response.success) {
        alert('用户创建成功');
        setShowCreateForm(false);
        setFormData({ username: '', password: '', email: '', full_name: '', role: 'user' });
        fetchUsers();
      } else {
        alert('创建失败: ' + response.message);
      }
    } catch (error: any) {
      console.error('创建用户失败:', error);
      alert('创建用户失败: ' + error.message);
    }
  };

  const handleToggleStatus = async (user: any) => {
    const action = user.is_active ? '禁用' : '启用';
    if (!window.confirm(`确定要${action}用户 ${user.username} 吗？`)) return;

    try {
      const response = await apiPatch(`/api/admin/users/${user.id}/status`, {
        is_active: !user.is_active
      }) as any;
      if (response.success) {
        fetchUsers();
      }
    } catch (error: any) {
      alert('操作失败: ' + error.message);
    }
  };

  const handleResetPassword = async (user: any) => {
    const newPassword = prompt(`请输入用户 ${user.username} 的新密码:`);
    if (!newPassword) return;

    try {
      const response = await apiPatch(`/api/admin/users/${user.id}/reset-password`, {
        new_password: newPassword
      }) as any;
      if (response.success) {
        alert('密码重置成功');
      }
    } catch (error: any) {
      alert('重置失败: ' + error.message);
    }
  };

  return (
    <div className="admin-user-management">
      <div className="admin-header">
        <h2>👥 用户管理</h2>
        <div>
          <button
            className="btn-primary"
            onClick={() => setShowCreateForm(!showCreateForm)}
            style={{ marginRight: '10px' }}
          >
            {showCreateForm ? '取消' : '➕ 新增用户'}
          </button>
          <button className="btn-secondary" onClick={onClose}>
            关闭
          </button>
        </div>
      </div>

      {showCreateForm && (
        <form className="create-user-form" onSubmit={handleCreateUser}>
          <h3>新增用户</h3>
          <div className="form-group">
            <label>用户名 *</label>
            <input
              type="text"
              value={formData.username}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({...formData, username: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>密码 *</label>
            <input
              type="password"
              value={formData.password}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({...formData, password: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>角色</label>
            <select
              value={formData.role}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setFormData({...formData, role: e.target.value})}
            >
              <option value="user">普通用户</option>
              <option value="admin">管理员</option>
            </select>
          </div>
          <div className="form-group">
            <label>全名</label>
            <input
              type="text"
              value={formData.full_name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({...formData, full_name: e.target.value})}
            />
          </div>
          <div className="form-actions">
            <button type="submit" className="btn-primary">保存</button>
          </div>
        </form>
      )}

      {loading ? (
        <p>加载中...</p>
      ) : (
        <table className="users-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>用户名</th>
              <th>全名</th>
              <th>角色</th>
              <th>状态</th>
              <th>最后登录</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user: any) => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.username}</td>
                <td>{user.full_name || '-'}</td>
                <td>
                  <span className={`role-badge ${user.role}`}>
                    {user.role === 'admin' ? '管理员' : '用户'}
                  </span>
                </td>
                <td>
                  <span className={`status-badge ${user.is_active ? 'active' : 'inactive'}`}>
                    {user.is_active ? '正常' : '已禁用'}
                  </span>
                </td>
                <td>{user.last_login ? new Date(user.last_login).toLocaleString() : '从未'}</td>
                <td>
                  <button
                    className="action-btn btn-toggle"
                    onClick={() => handleToggleStatus(user)}
                  >
                    {user.is_active ? '禁用' : '启用'}
                  </button>
                  <button
                    className="action-btn btn-reset"
                    onClick={() => handleResetPassword(user)}
                  >
                    重置密码
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
